<template>
    <div>
        <b-modal class="rounded-lg" size="md" v-model="modalMedicamento" :title="title" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer centered>
            <div class="d-flex justify-content-center">
                <b-col cols="12" sm="12" md="12" lg="12" class="mt-2">
                        <div class="d-flex">
                            <i class="icon_color_main fa fa-stethoscope fa-lg  my-auto mr-2"></i>
                            <b-form-input v-model="medicamento.nombre" name="name" autocomplete="off" class="form_input-color border-0 mt-1 psw" size="md" type="text" placeholder="Ingresa el nombre del medicamento" />
                        </div>
                        <div>
                            <span class="msjError ml-4">{{msjError}}</span> 
                        </div>
                </b-col>
            </div>
            <div class="d-flex justify-content-end mt-3 pr-3">
                <b-overlay
                    :show="busy"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                >
                    <button v-if="save" @click="guardar()" :disabled="busy" class="btn-modal-success border-0 px-3 pb-2 pt-1">Guardar</button>
                    <button v-if="edit" @click="editarDta()" :disabled="busy" class="btn-modal-success border-0 px-3 pb-2 pt-1">Actualizar</button>
                </b-overlay>
                <button @click="cerrarModal()" class="btn-modal-cancel px-3 pb-2 pt-1 ml-4">Cancelar</button>
            </div>
        </b-modal>
    </div> 
</template>

<script>
// import { EventBus } from "../../../EventBus"
import { url } from "../../../../settings"

export default {
    name: 'Medicamento',
    props: ['modalMedicamento'],

    data: () => ({
        busy: false,
        msjError: '',
        save: true,
        edit: false,
        title: 'Ingresa el medicamento',
        type: '',
        id: '',
        medicamento: {
            nombre: ''
        }
    }),

    methods: {
        async guardar() {
            this.msjError = ''
            if (this.medicamento.nombre == '') {
                this.msjError = 'El nombre es obligatorio'
            } else if (this.medicamento.nombre.length < 5) {
                this.msjError = 'Médicamento invalido'
            } else {
                this.busy = true
                try {
                    const res = await fetch(`${url}/api/catalogos/medicamentos`, {
                        method: 'post',
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            'Authorization': "Bearer "+ localStorage.getItem("token"),
                        },
                        body: JSON.stringify(this.medicamento),
                    });
                    // if (!res.ok) {
                    //     const message = `An error has occured: ${res.status} - ${res.statusText}`;
                    //     this.busy = false
                    //     throw new Error(message);
                    // }
                    const data = res.json()
                    console.log({Datas: data})
                    this.$emit('savedMedicamento')
                    this.busy = false
                    this.medicamento.nombre = ''
                    console.log({Modal: this.medicamento});
                } catch (error) {
                    console.log({Error:error});
                }
            }
        },

        async editarDta() {
            this.msjError = ''
            if (this.medicamento.nombre == '') {
                this.msjError = 'El nombre es obligatorio'
            } else if (this.medicamento.nombre.length < 5) {
                this.msjError = 'Médicamento invalido'
            } else {
                this.busy = true
                try {
                    const res = await fetch(`${url}/api/catalogos/medicamentos/${this.id}`, {
                        method: 'PUT',
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            'Authorization': "Bearer "+ localStorage.getItem("token"),
                        },
                        body: JSON.stringify(this.medicamento),
                    })
                    if (!res.ok) {
                        const message = `An error has occured: ${res.status} - ${res.statusText}`;
                        this.busy = false
                        throw new Error(message);
                    }
                    const data = res.json()
                    console.log(data);
                    this.busy = false
                    this.medicamento.nombre = ''
                    this.id = ''
                    this.title = 'Ingresa el medicamento'
                    this.$emit('savedMedicamento')
                    this.save = true
                    this.edit = false
                } catch (error) {
                    console.log({ErroressxD: error})
                }
            }
        },

        cerrarModal() {
            this.medicamento.nombre = ''
            this.save = true
            this.edit = false
            this.title = 'Ingresa el medicamento'
            this.$emit('closeAddMedicamento')
        },
        editDtaCat(id, name, type){
            console.log('Editar el medicamento');
            this.title = 'Editar el medicamento'
            this.save = false
            this.edit = true

            this.id = id
            this.medicamento.nombre = name
            this.type = type
        }
    },

    mounted() {
        
    }
}
</script>

<style scoped>

</style>